export default __webpack_public_path__ + "assets/17674fa5b7218156a250fe197fcf08b1.png";